(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["en-tete-pro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const revealTargets = document.querySelectorAll("h1[data-reveal-text]");

  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    if (!text) return;

    const words = text.trim().split(" ");

    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-section-1-colonne"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const revealTargets = document.querySelectorAll("h2[data-reveal-text]");
  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    const words = text.trim().split(" ");
    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Animation mot par mot (titre)
  const revealTargets = document.querySelectorAll("h2[data-reveal-text]");

  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    const words = text.trim().split(" ");

    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullscreen-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const revealTargets = document.querySelectorAll("[data-reveal-text]");
  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    const words = text.trim().split(" ");
    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-clean"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const revealTargets = document.querySelectorAll("h1[data-reveal-text]");

  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    if (!text) return;

    const words = text.trim().split(" ");

    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll('[data-animate]');
  headings.forEach((el) => {
    const text = el.getAttribute('data-animate');
    const words = text.trim().split(" ");
    el.innerHTML = words.map((word, i) => {
      return `<span class="word-fade" style="transition-delay:${i * 0.1}s">${word}&nbsp;</span>`;
    }).join("");

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.word-fade').forEach(span => {
            span.style.opacity = 1;
            span.style.transform = "translateY(0)";
          });
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-double"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const revealTargets = document.querySelectorAll("h2[data-reveal-text]");
  revealTargets.forEach((el) => {
    const text = el.getAttribute("data-reveal-text");
    const words = text.trim().split(" ");
    el.innerHTML = words
      .map((word, index) => {
        return `<span class="reveal-word" style="transition-delay:${index * 0.1}s">${word}&nbsp;</span>`;
      })
      .join("");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spans = entry.target.querySelectorAll(".reveal-word");
            spans.forEach((span) => {
              span.style.opacity = 1;
              span.style.transform = "translateY(0)";
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();
})();
